import React from 'react'
import EditSectionsList from '../../../../../features/components/Forms/EditForm/EditSectionsList'
import { useFacebookCampaignBudgetEditSections } from './useFacebookCampaignBudgetEditSections'

const FacebookEditSections = ({ campaign, isEditDataLoading }) => {
  const { editSections, sectionsInitialOpenStates } = useFacebookCampaignBudgetEditSections(campaign?.id)

  return (
    <EditSectionsList
      editSections={editSections}
      isEditDataLoading={isEditDataLoading}
      editItemData={campaign}
      sectionsInitialOpenStates={sectionsInitialOpenStates}
    />
  )
}

export default FacebookEditSections
